function addClass(element: HTMLElement, data: string): void {
    const classes = data.split(' ').filter((c) => c.length > 0);

    if (classes.length === 0) {
        return;
    }

    element.classList.add(...classes);
}

// ----------------------------------------------------------------------------

export default addClass;
